<template>

    <div class="home-container">

        <transition
                name="component-fade"
                mode="in-out"
                >
            <steps-navigator v-if="getActiveStep !== 1"></steps-navigator>
        </transition>

        <transition
                name="fade"
                mode="out-in">
            <first-step v-if="getActiveStep === 1"></first-step>
            <second-step v-else-if="getActiveStep === 2"></second-step>
            <third-step v-else-if="getActiveStep === 3"></third-step>
            <fourth-step v-else></fourth-step>
        </transition>

    </div>
</template>

<script>
    // @ is an alias to /src
    import Top from '@/components/top/Top.vue';
    import Bottom from '@/components/bottom/Bottom.vue';
    import FirstStep from '@/components/configuration_steps/firstStep/FirstStep.vue';
    import SecondStep from '@/components/configuration_steps/secondStep/SecondStep.vue';
    import ThirdStep from '@/components/configuration_steps/thirdStep/ThirdStep.vue';
    import FourthStep from "@/components/configuration_steps/fourthStep/FourthStep";
    import StepsNavigator from '@/components/configuration_steps/StepsNavigator.vue';


    export default {
        name: 'home',
        components: {
            Top,
            Bottom,
            FourthStep,
            ThirdStep,
            SecondStep,
            FirstStep,
            StepsNavigator
        },

        data() {
            return {}
        },

        computed: {
            getActiveStep() {
                return this.$store.state.activeConfigurationStep;
            }
        },

        watch: {
            getActiveStep(newCount, oldCount) {

                if (newCount !== 4) {
                    document.body.style.backgroundImage = "url('/gfx/imgs/bg.png')";
                } else {
                    document.body.style.backgroundImage = "url('/gfx/imgs/bg2.png')";
                }
            }
        },

        methods: {
            changeStep(step) {

                this.$store.commit({
                    type: 'changeActiveConfigurationStep',
                    step: step
                })
            }
        },

        mounted() {

            if (this.getActiveStep === 4) {
                document.body.style.backgroundImage = "url('/gfx/imgs/bg2.png')";
            }
        },

        beforeDestroy() {
            document.body.style.backgroundImage = "url('/gfx/imgs/bg.png')";
        }
    }
</script>

<style scoped lang="scss">
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity 0.5s ease;
        z-index: 99999;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
